import { createElement, Component, createContext } from 'react';
import { oneOf, string, object, func, bool, number } from 'prop-types';
import cnb from 'cnbuilder';
import { DraggableCore } from 'react-draggable';

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var RAFLoop =
/*#__PURE__*/
function () {
  function RAFLoop() {
    var _this = this;

    _classCallCheck(this, RAFLoop);
    /**
     * @description List of targets to update
     */


    this.targets = [];
    /**
     * @description ID of requested animation frame. Valuable only if loop is active and has items to iterate.
     */

    this.animationFrameID = 0;
    /**
     * @description Loop's state.
     */

    this._isActive = false;
    /**
     * @description Start the loop if it wasn't yet.
     */

    this.start = function () {
      if (!_this._isActive && _this.targets.length) {
        _this._isActive = true;
        _this.animationFrameID && cancelAnimationFrame(_this.animationFrameID);
        _this.animationFrameID = requestAnimationFrame(_this.rafCallback);
      }

      return _this;
    };
    /**
     * @description Stop the loop if is was active.
     */


    this.stop = function () {
      if (_this._isActive) {
        _this._isActive = false;
        _this.animationFrameID && cancelAnimationFrame(_this.animationFrameID);
        _this.animationFrameID = 0;
      }

      return _this;
    };
    /**
     * @description Callback that called each animation frame.
     */


    this.rafCallback = function () {
      if (!_this._isActive) {
        return 0;
      }

      for (var i = 0; i < _this.targets.length; i++) {
        !_this.targets[i]._unmounted && _this.targets[i].update();
      }

      return _this.animationFrameID = requestAnimationFrame(_this.rafCallback);
    };
    /**
     * @description Add target to the iteration list if it's not there.
     */


    this.addTarget = function (target) {
      var silent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (_this.targets.indexOf(target) === -1) {
        _this.targets.push(target);

        _this.targets.length === 1 && !silent && _this.start();
      }

      return _this;
    };
    /**
     * @description Remove target from iteration list if it was there.
     */


    this.removeTarget = function (target) {
      var idx = _this.targets.indexOf(target);

      if (idx !== -1) {
        _this.targets.splice(idx, 1);

        _this.targets.length === 0 && _this.stop();
      }

      return _this;
    };
  }
  /**
   * @description Loop's state.
   */


  _createClass(RAFLoop, [{
    key: "isActive",
    get: function get() {
      return this._isActive;
    }
  }]);

  return RAFLoop;
}();

var Loop = new RAFLoop();
var DIRECTION_AXIS;

(function (DIRECTION_AXIS) {
  DIRECTION_AXIS["X"] = "x";
  DIRECTION_AXIS["Y"] = "y";
})(DIRECTION_AXIS || (DIRECTION_AXIS = {}));

var ScrollbarTrack =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ScrollbarTrack, _React$Component);

  function ScrollbarTrack() {
    var _this;

    _classCallCheck(this, ScrollbarTrack);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ScrollbarTrack).apply(this, arguments));
    _this.element = null;

    _this.ref = function (ref) {
      typeof _this.props.elementRef === "function" && _this.props.elementRef(ref);
      _this.element = ref;
    };

    _this.handleClick = function (ev) {
      if (!ev || !_this.element || ev.button !== 0) {
        return;
      }

      if (typeof _this.props.onClick === "function" && ev.target === _this.element) {
        if (typeof ev.offsetX !== "undefined") {
          _this.props.onClick(ev, {
            axis: _this.props.axis,
            offset: _this.props.axis === DIRECTION_AXIS.X ? ev.offsetX : ev.offsetY
          });
        } else {
          // support for old browsers
          var rect = _this.element.getBoundingClientRect();

          _this.props.onClick(ev, {
            axis: _this.props.axis,
            offset: _this.props.axis === DIRECTION_AXIS.X ? ev.clientX - rect.left : ev.clientY - rect.top
          });
        }
      }

      return true;
    };

    return _this;
  }

  _createClass(ScrollbarTrack, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.element) {
        this.setState(function () {
          throw new Error("Element was not created. Possibly you haven't provided HTMLElement to renderer's `elementRef` function.");
        });
        return;
      }

      this.element.addEventListener("click", this.handleClick);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.element) {
        this.element.removeEventListener("click", this.handleClick);
        this.element = null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          elementRef = _this$props.elementRef,
          renderer = _this$props.renderer,
          axis = _this$props.axis,
          onClick = _this$props.onClick,
          props = _objectWithoutProperties(_this$props, ["elementRef", "renderer", "axis", "onClick"]);

      props.className = cnb("ScrollbarTrack", axis === DIRECTION_AXIS.X ? "ScrollbarTrack-X" : "ScrollbarTrack-Y", props.className);
      return renderer ? renderer(_objectSpread({}, props, {
        axis: axis,
        elementRef: this.ref
      })) : createElement("div", Object.assign({}, props, {
        ref: this.ref
      }));
    }
  }]);

  return ScrollbarTrack;
}(Component);

ScrollbarTrack.propTypes = {
  axis: oneOf([DIRECTION_AXIS.X, DIRECTION_AXIS.Y]),
  className: string,
  style: object,
  onClick: func,
  elementRef: func,
  renderer: func
};

var ScrollbarThumb =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ScrollbarThumb, _React$Component);

  function ScrollbarThumb() {
    var _this;

    _classCallCheck(this, ScrollbarThumb);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ScrollbarThumb).apply(this, arguments));
    _this.element = null;
    _this.initialOffsetX = 0;
    _this.initialOffsetY = 0;
    _this.lastDragData = {
      x: 0,
      y: 0,
      deltaX: 0,
      deltaY: 0,
      lastX: 0,
      lastY: 0
    };

    _this.handleOnDragStart = function (ev, data) {
      if (!_this.element) {
        _this.handleOnDragStop(ev, data);

        return;
      }

      if (global.document) {
        _this.prevUserSelect = global.document.body.style.userSelect;
        global.document.body.style.userSelect = "none"; //@ts-ignore

        _this.prevOnSelectStart = global.document.onselectstart; //@ts-ignore

        global.document.onselectstart = ScrollbarThumb.selectStartReplacer;
      }

      _this.props.onDragStart && _this.props.onDragStart(_this.lastDragData = {
        x: data.x - _this.initialOffsetX,
        y: data.y - _this.initialOffsetY,
        lastX: data.lastX - _this.initialOffsetX,
        lastY: data.lastY - _this.initialOffsetY,
        deltaX: data.deltaX,
        deltaY: data.deltaY
      });

      _this.element.classList.add("dragging");
    };

    _this.handleOnDrag = function (ev, data) {
      if (!_this.element) {
        _this.handleOnDragStop(ev, data);

        return;
      }

      _this.props.onDrag && _this.props.onDrag(_this.lastDragData = {
        x: data.x - _this.initialOffsetX,
        y: data.y - _this.initialOffsetY,
        lastX: data.lastX - _this.initialOffsetX,
        lastY: data.lastY - _this.initialOffsetY,
        deltaX: data.deltaX,
        deltaY: data.deltaY
      });
    };

    _this.handleOnDragStop = function (ev, data) {
      var resultData = data ? {
        x: data.x - _this.initialOffsetX,
        y: data.y - _this.initialOffsetY,
        lastX: data.lastX - _this.initialOffsetX,
        lastY: data.lastY - _this.initialOffsetY,
        deltaX: data.deltaX,
        deltaY: data.deltaY
      } : _this.lastDragData;
      _this.props.onDragEnd && _this.props.onDragEnd(resultData);
      _this.element && _this.element.classList.remove("dragging");

      if (global.document) {
        global.document.body.style.userSelect = _this.prevUserSelect;
        _this.prevUserSelect = null; // @ts-ignore

        global.document.onselectstart = _this.prevOnSelectStart;
        _this.prevOnSelectStart = null;
      }

      _this.initialOffsetX = 0;
      _this.initialOffsetY = 0;
      _this.lastDragData = {
        x: 0,
        y: 0,
        deltaX: 0,
        deltaY: 0,
        lastX: 0,
        lastY: 0
      };
    };

    _this.handleOnMouseDown = function (ev) {
      if (!_this.element) {
        return;
      }

      ev.stopPropagation();

      if (typeof ev.offsetX !== "undefined") {
        _this.initialOffsetX = ev.offsetX;
        _this.initialOffsetY = ev.offsetY;
      } else {
        var rect = _this.element.getBoundingClientRect();

        _this.initialOffsetX = ev.clientX - rect.left;
        _this.initialOffsetY = ev.clientY - rect.top;
      }
    };

    _this.ref = function (ref) {
      typeof _this.props.elementRef === "function" && _this.props.elementRef(ref);
      _this.element = ref;
    };

    return _this;
  }

  _createClass(ScrollbarThumb, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.element) {
        this.setState(function () {
          throw new Error("Element was not created. Possibly you haven't provided HTMLElement to renderer's `elementRef` function.");
        });
        return;
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.handleOnDragStop();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          elementRef = _this$props.elementRef,
          renderer = _this$props.renderer,
          axis = _this$props.axis,
          onClick = _this$props.onClick,
          onDrag = _this$props.onDrag,
          onDragEnd = _this$props.onDragEnd,
          onDragStart = _this$props.onDragStart,
          props = _objectWithoutProperties(_this$props, ["elementRef", "renderer", "axis", "onClick", "onDrag", "onDragEnd", "onDragStart"]);

      props.className = cnb("ScrollbarThumb", axis === DIRECTION_AXIS.X ? "ScrollbarThumb-X" : "ScrollbarThumb-Y", props.className);
      return createElement(DraggableCore, {
        allowAnyClick: false,
        enableUserSelectHack: false,
        onMouseDown: this.handleOnMouseDown,
        onDrag: this.handleOnDrag,
        onStart: this.handleOnDragStart,
        onStop: this.handleOnDragStop
      }, renderer ? renderer(_objectSpread({}, props, {
        axis: axis,
        elementRef: this.ref
      })) : createElement("div", Object.assign({}, props, {
        ref: this.ref
      })));
    }
  }]);

  return ScrollbarThumb;
}(Component);

ScrollbarThumb.propTypes = {
  axis: oneOf([DIRECTION_AXIS.X, DIRECTION_AXIS.Y]),
  className: string,
  style: object,
  onClick: func,
  elementRef: func,
  renderer: func
};

ScrollbarThumb.selectStartReplacer = function () {
  return false;
};

var doc = global.document || null;
var isReverseRTLScrollNeeded = null;
/**
 * @description Detect need of horizontal scroll reverse while RTL
 */

var shouldReverseRTLScroll = function shouldReverseRTLScroll() {
  var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  if (!force && isReverseRTLScrollNeeded !== null) {
    return isReverseRTLScrollNeeded;
  }

  if (!doc) {
    return isReverseRTLScrollNeeded = false;
  }

  var el = doc.createElement("div");
  var child = doc.createElement("div");
  el.setAttribute("style", "display:block;position:absolute;width:100px;height:100px;top:-9999px;overflow:scroll;direction:rtl;");
  child.setAttribute("style", "display:block;position:relative;width:1000px;height:1000px;direction:rtl;");
  el.appendChild(child);
  doc.body.appendChild(el);
  el.scrollLeft;
  el.scrollLeft = 45;
  isReverseRTLScrollNeeded = el.scrollLeft === 0;
  doc.body.removeChild(el);
  return isReverseRTLScrollNeeded;
};
/**
 * @description Return element's height without padding
 *
 * ts-ignore here is okay here, because it brigs around 40% of performance
 */


var getInnerHeight = function getInnerHeight(el) {
  var styles = getComputedStyle(el);

  if (styles.boxSizing === "border-box") {
    return Math.max( // @ts-ignore
    (parseFloat(styles.height) || 0) - ( // @ts-ignore
    parseFloat(styles.paddingTop) || 0) - ( // @ts-ignore
    parseFloat(styles.paddingBottom) || 0), 0);
  } // @ts-ignore


  return parseFloat(styles.height) || 0;
};
/**
 * @description Return element's width without padding
 *
 * ts-ignore here is okay here, because it brigs around 40% of performance
 */


var getInnerWidth = function getInnerWidth(el) {
  var styles = getComputedStyle(el);

  if (styles.boxSizing === "border-box") {
    return Math.max( // @ts-ignore
    (parseFloat(styles.width) || 0) - ( // @ts-ignore
    parseFloat(styles.paddingLeft) || 0) - ( // @ts-ignore
    parseFloat(styles.paddingRight) || 0), 0);
  } // @ts-ignore


  return parseFloat(styles.width) || 0;
};
/**
 * @description Return unique UUID v4
 */


var uuid = function uuid() {
  var uuid = "";

  for (var i = 0; i < 32; i++) {
    if (i === 8 || i === 20) {
      uuid += "-" + (Math.random() * 16 | 0).toString(16);
    } else if (i === 12) {
      uuid += "-4";
    } else if (i === 16) {
      uuid += "-" + (Math.random() * 16 | 0 & 3 | 8).toString(16);
    } else {
      uuid += (Math.random() * 16 | 0).toString(16);
    }
  }

  return uuid;
};
/**
 * @description Calculate thumb size for given viewport and track parameters
 *
 * @param {number} contentSize - Scrollable content size
 * @param {number} viewportSize - Viewport size
 * @param {number} trackSize - Track size thumb can move
 * @param {number} minimalSize - Minimal thumb's size
 * @param {number} maximalSize - Maximal thumb's size
 */


function calcThumbSize(contentSize, viewportSize, trackSize, minimalSize, maximalSize) {
  if (viewportSize >= contentSize) {
    return 0;
  }

  var thumbSize = viewportSize / contentSize * trackSize;

  if (typeof maximalSize === "number") {
    thumbSize = Math.min(maximalSize, thumbSize);
  }

  if (typeof minimalSize === "number") {
    thumbSize = Math.max(minimalSize, thumbSize);
  }

  return thumbSize;
}
/**
 * @description Calculate thumb offset for given viewport, track and thumb parameters
 *
 * @param {number} contentSize - Scrollable content size
 * @param {number} viewportSize - Viewport size
 * @param {number} trackSize - Track size thumb can move
 * @param {number} thumbSize - Thumb size
 * @param {number} scroll - Scroll value to represent
 */


function calcThumbOffset(contentSize, viewportSize, trackSize, thumbSize, scroll) {
  if (!scroll || !thumbSize || viewportSize >= contentSize) {
    return 0;
  }

  return (trackSize - thumbSize) * scroll / (contentSize - viewportSize);
}
/**
 * @description Calculate scroll for given viewport, track and thumb parameters
 *
 * @param {number} contentSize - Scrollable content size
 * @param {number} viewportSize - Viewport size
 * @param {number} trackSize - Track size thumb can move
 * @param {number} thumbSize - Thumb size
 * @param {number} thumbOffset - Thumb's offset representing the scroll
 */


function calcScrollForThumbOffset(contentSize, viewportSize, trackSize, thumbSize, thumbOffset) {
  if (!thumbOffset || !thumbSize || viewportSize >= contentSize) {
    return 0;
  }

  return thumbOffset * (contentSize - viewportSize) / (trackSize - thumbSize);
}

var scrollbarWidth = null;
/**
 * @description Returns scrollbar width specific for current environment
 */

function getScrollbarWidth() {
  var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  if (!force && scrollbarWidth !== null) {
    return scrollbarWidth;
  }

  if (!doc) {
    return scrollbarWidth = 0;
  }

  var el = doc.createElement("div");
  el.setAttribute("style", "display:block;position:absolute;width:100px;height:100px;top:-9999px;overflow:scroll;");
  doc.body.appendChild(el);
  scrollbarWidth = el.offsetWidth - el.clientWidth;
  doc.body.removeChild(el);
  return scrollbarWidth;
}

var Emittr =
/*#__PURE__*/
function () {
  function Emittr() {
    var maxHandlers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;

    _classCallCheck(this, Emittr);

    this.setMaxHandlers(maxHandlers);
    this._handlers = Object.create(null);
  }

  _createClass(Emittr, [{
    key: "setMaxHandlers",
    value: function setMaxHandlers(count) {
      if (typeof count !== "number" || count < 0 || !count) {
        throw new TypeError("Expected maxHandlers to be a positive number, got '".concat(count, "' of type ").concat(_typeof(count)));
      }

      this._maxHandlers = count;
      return this;
    }
  }, {
    key: "getMaxHandlers",
    value: function getMaxHandlers() {
      return this._maxHandlers;
    }
  }, {
    key: "emit",
    value: function emit(name) {
      if (_typeof(this._handlers[name]) !== "object" || !Array.isArray(this._handlers[name])) {
        return false;
      }

      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      Emittr._callEventHandlers(this, this._handlers[name], args);

      return true;
    }
  }, {
    key: "_wrapOnceHandler",
    value: function _wrapOnceHandler(name, handler) {
      var onceState = {
        fired: false,
        handler: handler,
        wrappedHandler: undefined,
        emitter: this,
        event: name
      };

      var wrappedHandler = Emittr._onceWrapper.bind(onceState);

      onceState.wrappedHandler = wrappedHandler;
      wrappedHandler.handler = handler;
      wrappedHandler.event = name;
      return wrappedHandler;
    }
  }, {
    key: "on",
    value: function on(name, handler) {
      Emittr._addHandler(this, name, handler);

      return this;
    }
  }, {
    key: "prependOn",
    value: function prependOn(name, handler) {
      Emittr._addHandler(this, name, handler, true);

      return this;
    }
  }, {
    key: "once",
    value: function once(name, handler) {
      if (typeof handler !== "function") {
        throw new TypeError("Expected event handler to be a function, got " + _typeof(handler));
      }

      Emittr._addHandler(this, name, this._wrapOnceHandler(name, handler));

      return this;
    }
  }, {
    key: "prependOnce",
    value: function prependOnce(name, handler) {
      if (typeof handler !== "function") {
        throw new TypeError("Expected event handler to be a function, got " + _typeof(handler));
      }

      Emittr._addHandler(this, name, this._wrapOnceHandler(name, handler), true);

      return this;
    }
  }, {
    key: "off",
    value: function off(name, handler) {
      Emittr._removeHandler(this, name, handler);

      return this;
    }
  }, {
    key: "removeAllHandlers",
    value: function removeAllHandlers() {
      var handlers = this._handlers;
      this._handlers = Object.create(null);
      var removeHandlers = handlers["removeHandler"];
      delete handlers["removeHandler"];
      var idx, eventName;

      for (eventName in handlers) {
        for (idx = handlers[eventName].length - 1; idx >= 0; idx--) {
          Emittr._callEventHandlers(this, removeHandlers, [eventName, handlers[eventName][idx].handler || handlers[eventName][idx]]);
        }
      }

      return this;
    }
  }], [{
    key: "_callEventHandlers",
    value: function _callEventHandlers(emitter, handlers, args) {
      if (!handlers.length) {
        return;
      }

      if (handlers.length === 1) {
        Reflect.apply(handlers[0], emitter, args);
        return;
      }

      handlers = _toConsumableArray(handlers);
      var idx;

      for (idx = 0; idx < handlers.length; idx++) {
        Reflect.apply(handlers[idx], emitter, args);
      }
    }
  }]);

  return Emittr;
}();

Emittr._addHandler = function (emitter, name, handler) {
  var prepend = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  if (typeof handler !== "function") {
    throw new TypeError("Expected event handler to be a function, got " + _typeof(handler));
  }

  emitter._handlers[name] = emitter._handlers[name] || [];
  emitter.emit("addHandler", name, handler);
  prepend ? emitter._handlers[name].unshift(handler) : emitter._handlers[name].push(handler);
  return emitter;
};

Emittr._onceWrapper = function _onceWrapper() {
  if (!this.fired) {
    this.fired = true;
    this.emitter.off(this.event, this.wrappedHandler);

    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    Reflect.apply(this.handler, this.emitter, args);
  }
};

Emittr._removeHandler = function (emitter, name, handler) {
  if (typeof handler !== "function") {
    throw new TypeError("Expected event handler to be a function, got " + _typeof(handler));
  }

  if (typeof emitter._handlers[name] === "undefined" || !emitter._handlers[name].length) {
    return emitter;
  }

  var idx = -1;

  if (emitter._handlers[name].length === 1) {
    if (emitter._handlers[name][0] === handler || emitter._handlers[name][0].handler === handler) {
      idx = 0;
      handler = emitter._handlers[name][0].handler || emitter._handlers[name][0];
    }
  } else {
    for (idx = emitter._handlers[name].length - 1; idx >= 0; idx--) {
      if (emitter._handlers[name][idx] === handler || emitter._handlers[name][idx].handler === handler) {
        handler = emitter._handlers[name][idx].handler || emitter._handlers[name][idx];
        break;
      }
    }
  }

  if (idx === -1) {
    return emitter;
  }

  idx === 0 ? emitter._handlers[name].shift() : emitter._handlers[name].splice(idx, 1);
  emitter.emit("removeHandler", name, handler);
  return emitter;
};

var reverseRTL = shouldReverseRTLScroll();
var SCROLLBAR_TRACK_CLICK_BEHAVIOR;

(function (SCROLLBAR_TRACK_CLICK_BEHAVIOR) {
  SCROLLBAR_TRACK_CLICK_BEHAVIOR["JUMP"] = "jump";
  SCROLLBAR_TRACK_CLICK_BEHAVIOR["STEP"] = "step";
})(SCROLLBAR_TRACK_CLICK_BEHAVIOR || (SCROLLBAR_TRACK_CLICK_BEHAVIOR = {}));

var ScrollbarContext = createContext({
  parentScrollbar: null
});

var Scrollbar =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Scrollbar, _React$Component);

  function Scrollbar(props) {
    var _this;

    _classCallCheck(this, Scrollbar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Scrollbar).call(this, props));
    /**
     * @description Get current scroll-related values.<br/>
     * If <i>force</i> if truthy - will recalculate them instead of returning cached values.
     *
     * @return ScrollValues
     */

    _this.getScrollValues = function () {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (_this.scrollValues && !force) {
        return _objectSpread({}, _this.scrollValues);
      }

      var scrollValues = {
        clientHeight: 0,
        clientWidth: 0,
        scrollHeight: 0,
        scrollWidth: 0,
        scrollTop: 0,
        scrollLeft: 0,
        scrollYBlocked: false,
        scrollXBlocked: false,
        scrollYPossible: false,
        scrollXPossible: false,
        trackYVisible: false,
        trackXVisible: false,
        isRTL: undefined
      };
      scrollValues.isRTL = _this.state.isRTL;
      scrollValues.scrollYBlocked = _this.props.noScroll || _this.props.noScrollY;
      scrollValues.scrollXBlocked = _this.props.noScroll || _this.props.noScrollX;

      if (_this.contentElement) {
        scrollValues.clientHeight = _this.contentElement.clientHeight;
        scrollValues.clientWidth = _this.contentElement.clientWidth;
        scrollValues.scrollHeight = _this.contentElement.scrollHeight;
        scrollValues.scrollWidth = _this.contentElement.scrollWidth;
        scrollValues.scrollTop = _this.contentElement.scrollTop;
        scrollValues.scrollLeft = _this.contentElement.scrollLeft;
        scrollValues.scrollYPossible = !scrollValues.scrollYBlocked && scrollValues.scrollHeight > scrollValues.clientHeight;
        scrollValues.scrollXPossible = !scrollValues.scrollXBlocked && scrollValues.scrollWidth > scrollValues.clientWidth;
        scrollValues.trackYVisible = scrollValues.scrollYPossible || _this.props.permanentTracks || _this.props.permanentTrackY;
        scrollValues.trackXVisible = scrollValues.scrollXPossible || _this.props.permanentTracks || _this.props.permanentTrackX;
      }

      return scrollValues;
    };
    /**
     * @description Scroll to top border
     */


    _this.scrollToTop = function () {
      if (_this.contentElement) {
        _this.contentElement.scrollTop = 0;
      }

      return _assertThisInitialized(_this);
    };
    /**
     * @description Scroll to left border
     */


    _this.scrollToLeft = function () {
      if (_this.contentElement) {
        _this.contentElement.scrollLeft = 0;
      }

      return _assertThisInitialized(_this);
    };
    /**
     * @description Scroll to bottom border
     */


    _this.scrollToBottom = function () {
      if (_this.contentElement) {
        _this.contentElement.scrollTop = _this.contentElement.scrollHeight - _this.contentElement.clientHeight;
      }

      return _assertThisInitialized(_this);
    };
    /**
     * @description Scroll to right border
     */


    _this.scrollToRight = function () {
      if (_this.contentElement) {
        _this.contentElement.scrollLeft = _this.contentElement.scrollWidth - _this.contentElement.clientWidth;
      }

      return _assertThisInitialized(_this);
    };
    /**
     * @description Set the scrolls at given coordinates.<br/>
     * If coordinate is undefined - current scroll value will persist.
     */


    _this.scrollTo = function (x, y) {
      if (_this.contentElement) {
        typeof x === "number" && (_this.contentElement.scrollLeft = x);
        typeof y === "number" && (_this.contentElement.scrollTop = y);
      }

      return _assertThisInitialized(_this);
    };
    /**
     * @description Center the viewport at given coordinates.<br/>
     * If coordinate is undefined - current scroll value will persist.
     */


    _this.centerAt = function (x, y) {
      if (_this.contentElement) {
        typeof x === "number" && (_this.contentElement.scrollLeft = x - _this.contentElement.clientWidth / 2);
        typeof y === "number" && (_this.contentElement.scrollTop = y - _this.contentElement.clientHeight / 2);
      }

      return _assertThisInitialized(_this);
    };

    _this.update = function () {
      var force = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!_this.contentElement) {
        return;
      } // autodetect direction if not defined


      if (typeof _this.state.isRTL === "undefined") {
        _this.setState({
          isRTL: getComputedStyle(_this.contentElement).direction === "rtl"
        });

        return _this.getScrollValues();
      }

      var scrollValues = _this.getScrollValues(true);

      var prevScrollValues = _objectSpread({}, _this.scrollValues);

      var bitmask = 0;

      if (!force) {
        prevScrollValues.clientHeight !== scrollValues.clientHeight && (bitmask |= 1 << 0);
        prevScrollValues.clientWidth !== scrollValues.clientWidth && (bitmask |= 1 << 1);
        prevScrollValues.scrollHeight !== scrollValues.scrollHeight && (bitmask |= 1 << 2);
        prevScrollValues.scrollWidth !== scrollValues.scrollWidth && (bitmask |= 1 << 3);
        prevScrollValues.scrollTop !== scrollValues.scrollTop && (bitmask |= 1 << 4);
        prevScrollValues.scrollLeft !== scrollValues.scrollLeft && (bitmask |= 1 << 5);
        prevScrollValues.scrollYBlocked !== scrollValues.scrollYBlocked && (bitmask |= 1 << 6);
        prevScrollValues.scrollXBlocked !== scrollValues.scrollXBlocked && (bitmask |= 1 << 7);
        prevScrollValues.scrollYPossible !== scrollValues.scrollYPossible && (bitmask |= 1 << 8);
        prevScrollValues.scrollXPossible !== scrollValues.scrollXPossible && (bitmask |= 1 << 9);
        prevScrollValues.trackYVisible !== scrollValues.trackYVisible && (bitmask |= 1 << 10);
        prevScrollValues.trackXVisible !== scrollValues.trackXVisible && (bitmask |= 1 << 11);
        prevScrollValues.isRTL !== scrollValues.isRTL && (bitmask |= 1 << 12); // if not forced and nothing has changed - skip this update

        if (bitmask === 0) {
          return prevScrollValues;
        }
      } else {
        bitmask = 8191;
      }

      if (!_this.props.native && _this.holderElement) {
        bitmask & 1 << 2 && (_this.props.translateContentSizesToHolder || _this.props.translateContentSizeYToHolder) && (_this.holderElement.style.height = scrollValues.scrollHeight + "px");
        bitmask & 1 << 3 && (_this.props.translateContentSizesToHolder || _this.props.translateContentSizeXToHolder) && (_this.holderElement.style.width = scrollValues.scrollWidth + "px");

        if (scrollValues.clientWidth === 0 && scrollValues.scrollWidth && scrollValues.clientHeight === 0 && scrollValues.scrollHeight && (_this.props.translateContentSizesToHolder || _this.props.translateContentSizeYToHolder || _this.props.translateContentSizeXToHolder)) {
          return;
        }
      } // if scrollbars visibility has changed


      if (bitmask & 1 << 10 || bitmask & 1 << 11) {
        prevScrollValues.scrollYBlocked = scrollValues.scrollYBlocked;
        prevScrollValues.scrollXBlocked = scrollValues.scrollXBlocked;
        prevScrollValues.scrollYPossible = scrollValues.scrollYPossible;
        prevScrollValues.scrollXPossible = scrollValues.scrollXPossible;

        if (_this.trackYElement && bitmask & 1 << 10) {
          _this.trackYElement.style.display = scrollValues.trackYVisible ? null : "none";
        }

        if (_this.trackXElement && bitmask & 1 << 11) {
          _this.trackXElement.style.display = scrollValues.trackXVisible ? null : "none";
        }

        _this.scrollValues = prevScrollValues;

        _this.setState({
          trackYVisible: _this.scrollValues.trackYVisible = scrollValues.trackYVisible,
          trackXVisible: _this.scrollValues.trackXVisible = scrollValues.trackXVisible
        });

        return;
      }

      (_this.props.native ? _this.updaterNative : _this.updaterCustom)(bitmask, scrollValues);
      _this.scrollValues = scrollValues;

      _this.eventEmitter.emit("update", _objectSpread({}, scrollValues), prevScrollValues);

      (bitmask & 1 << 4 || bitmask & 1 << 5) && _this.eventEmitter.emit("scroll", _objectSpread({}, scrollValues), prevScrollValues);
      return _this.scrollValues;
    };

    _this.updaterNative = function () {
      // just for future
      return true;
    };

    _this.updaterCustom = function (bitmask, scrollValues) {
      if (_this.trackYElement) {
        if (_this.thumbYElement && (bitmask & 1 << 0 || bitmask & 1 << 2 || bitmask & 1 << 4 || bitmask & 1 << 6 || bitmask & 1 << 8)) {
          if (scrollValues.scrollYPossible) {
            var trackInnerSize = getInnerHeight(_this.trackYElement);
            var thumbSize = calcThumbSize(scrollValues.scrollHeight, scrollValues.clientHeight, trackInnerSize, _this.props.minimalThumbYSize || _this.props.minimalThumbSize, _this.props.maximalThumbYSize || _this.props.maximalThumbSize);
            var thumbOffset = calcThumbOffset(scrollValues.scrollHeight, scrollValues.clientHeight, trackInnerSize, thumbSize, scrollValues.scrollTop);
            _this.thumbYElement.style.transform = "translateY(".concat(thumbOffset, "px)");
            _this.thumbYElement.style.height = thumbSize + "px";
            _this.thumbYElement.style.display = null;
          } else {
            _this.thumbYElement.style.transform = null;
            _this.thumbYElement.style.height = "0px";
            _this.thumbYElement.style.display = "none";
          }
        }
      }

      if (_this.trackXElement) {
        if (_this.thumbXElement && (bitmask & 1 << 1 || bitmask & 1 << 3 || bitmask & 1 << 5 || bitmask & 1 << 7 || bitmask & 1 << 9 || bitmask & 1 << 12)) {
          if (scrollValues.scrollXPossible) {
            var _trackInnerSize = getInnerWidth(_this.trackXElement);

            var _thumbSize = calcThumbSize(scrollValues.scrollWidth, scrollValues.clientWidth, _trackInnerSize, _this.props.minimalThumbXSize || _this.props.minimalThumbSize, _this.props.maximalThumbXSize || _this.props.maximalThumbSize);

            var _thumbOffset = calcThumbOffset(scrollValues.scrollWidth, scrollValues.clientWidth, _trackInnerSize, _thumbSize, scrollValues.scrollLeft);

            if (_this.state.isRTL && reverseRTL) {
              _thumbOffset += _trackInnerSize - _thumbSize;
            }

            _this.thumbXElement.style.transform = "translateX(".concat(_thumbOffset, "px)");
            _this.thumbXElement.style.width = _thumbSize + "px";
            _this.thumbXElement.style.display = null;
          } else {
            _this.thumbXElement.style.transform = null;
            _this.thumbXElement.style.width = "0px";
            _this.thumbXElement.style.display = "none";
          }
        }
      }

      return true;
    };

    _this.elementRefHolder = function (ref) {
      _this.holderElement = ref;
      typeof _this.props.elementRef === "function" && _this.props.elementRef(ref);
    };

    _this.elementRefWrapper = function (ref) {
      _this.wrapperElement = ref;
      typeof _this.props.wrapperProps.elementRef === "function" && _this.props.wrapperProps.elementRef(ref);
    };

    _this.elementRefContent = function (ref) {
      _this.contentElement = ref;
      typeof _this.props.contentProps.elementRef === "function" && _this.props.contentProps.elementRef(ref);
    };

    _this.elementRefTrackX = function (ref) {
      _this.trackXElement = ref;
      typeof _this.props.trackXProps.elementRef === "function" && _this.props.trackXProps.elementRef(ref);
    };

    _this.elementRefTrackY = function (ref) {
      _this.trackYElement = ref;
      typeof _this.props.trackYProps.elementRef === "function" && _this.props.trackYProps.elementRef(ref);
    };

    _this.elementRefThumbX = function (ref) {
      _this.thumbXElement = ref;
      typeof _this.props.thumbXProps.elementRef === "function" && _this.props.thumbXProps.elementRef(ref);
    };

    _this.elementRefThumbY = function (ref) {
      _this.thumbYElement = ref;
      typeof _this.props.thumbYProps.elementRef === "function" && _this.props.thumbYProps.elementRef(ref);
    };

    _this.handleTrackXClick = function (ev, values) {
      _this.props.trackXProps.onClick && _this.props.trackXProps.onClick(ev, values);

      if (!_this.contentElement || !_this.trackXElement || !_this.thumbXElement || !_this.scrollValues || !_this.scrollValues.scrollXPossible) {
        return;
      }

      _this._scrollDetection();

      var thumbSize = _this.thumbXElement.clientWidth;
      var trackInnerSize = getInnerWidth(_this.trackXElement);
      var thumbOffset = (_this.scrollValues.isRTL && reverseRTL ? values.offset + thumbSize / 2 - trackInnerSize : values.offset - thumbSize / 2) - ( //@ts-ignore
      parseFloat(getComputedStyle(_this.trackXElement).paddingLeft) || 0);
      var target = calcScrollForThumbOffset(_this.scrollValues.scrollWidth, _this.scrollValues.clientWidth, trackInnerSize, thumbSize, thumbOffset);

      if (_this.props.trackClickBehavior === SCROLLBAR_TRACK_CLICK_BEHAVIOR.STEP) {
        target = (_this.scrollValues.isRTL ? _this.scrollValues.scrollLeft > target : _this.scrollValues.scrollLeft < target) ? _this.scrollValues.scrollLeft + _this.scrollValues.clientWidth : _this.scrollValues.scrollLeft - _this.scrollValues.clientWidth;
      }

      _this.contentElement.scrollLeft = target;
    };

    _this.handleTrackYClick = function (ev, values) {
      _this.props.trackYProps.onClick && _this.props.trackYProps.onClick(ev, values);

      if (!_this.contentElement || !_this.trackYElement || !_this.thumbYElement || !_this.scrollValues || !_this.scrollValues.scrollYPossible) {
        return;
      }

      _this._scrollDetection();

      var thumbSize = _this.thumbYElement.clientHeight;
      var target = calcScrollForThumbOffset(_this.scrollValues.scrollHeight, _this.scrollValues.clientHeight, getInnerHeight(_this.trackYElement), thumbSize, values.offset - thumbSize / 2) - ( //@ts-ignore
      parseFloat(getComputedStyle(_this.trackYElement).paddingTop) || 0);

      if (_this.props.trackClickBehavior === SCROLLBAR_TRACK_CLICK_BEHAVIOR.JUMP) {
        _this.contentElement.scrollTop = target;
      } else {
        _this.contentElement.scrollTop = _this.scrollValues.scrollTop < target ? _this.scrollValues.scrollTop + _this.scrollValues.clientHeight : _this.scrollValues.scrollTop - _this.scrollValues.clientHeight;
      }
    };

    _this.handleTrackYMouseWheel = function (ev) {
      _this.props.trackYProps && _this.props.trackYProps.onWheel && _this.props.trackYProps.onWheel(ev);

      _this._scrollDetection();

      if (!_this.contentElement || _this.scrollValues.scrollYBlocked) {
        return;
      }

      _this.scrollTop += ev.deltaY;
    };

    _this.handleTrackXMouseWheel = function (ev) {
      _this.props.trackXProps && _this.props.trackXProps.onWheel && _this.props.trackXProps.onWheel(ev);

      _this._scrollDetection();

      if (!_this.contentElement || _this.scrollValues.scrollXBlocked) {
        return;
      }

      _this.scrollLeft += ev.deltaX;
    };

    _this.handleThumbXDrag = function (data) {
      if (!_this.trackXElement || !_this.thumbXElement || !_this.contentElement || !_this.scrollValues || !_this.scrollValues.scrollXPossible) {
        return;
      }

      _this._scrollDetection();

      var trackRect = _this.trackXElement.getBoundingClientRect();

      var styles = getComputedStyle(_this.trackXElement); //@ts-ignore

      var paddingLeft = parseFloat(styles.paddingLeft) || 0; //@ts-ignore

      var paddingRight = parseFloat(styles.paddingRight) || 0;
      var trackInnerSize = trackRect.width - paddingLeft - paddingRight;
      var thumbSize = _this.thumbXElement.clientWidth;
      var offset = _this.scrollValues.isRTL && reverseRTL ? data.x + thumbSize - trackInnerSize + paddingLeft : data.lastX - paddingLeft;
      _this.contentElement.scrollLeft = calcScrollForThumbOffset(_this.scrollValues.scrollWidth, _this.scrollValues.clientWidth, trackInnerSize, thumbSize, offset);
    };

    _this.handleThumbYDrag = function (data) {
      if (!_this.contentElement || !_this.trackYElement || !_this.thumbYElement || !_this.scrollValues || !_this.scrollValues.scrollYPossible) {
        return;
      }

      _this._scrollDetection();

      var trackRect = _this.trackYElement.getBoundingClientRect();

      var styles = getComputedStyle(_this.trackYElement); //@ts-ignore

      var paddingTop = parseFloat(styles.paddingTop) || 0; //@ts-ignore

      var paddingBottom = parseFloat(styles.paddingBottom) || 0;
      var trackInnerSize = trackRect.height - paddingTop - paddingBottom;
      var thumbSize = _this.thumbYElement.clientHeight;
      var offset = data.y - paddingTop;
      _this.contentElement.scrollTop = calcScrollForThumbOffset(_this.scrollValues.scrollHeight, _this.scrollValues.clientHeight, trackInnerSize, thumbSize, offset);
    };

    _this.handleContentScroll = function () {
      _this._scrollDetection();
    };

    _this._scrollDetection = function () {
      !_this._scrollDetectionTO && _this.eventEmitter.emit("scrollStart", _this.getScrollValues());
      _this._scrollDetectionTO && global.window && global.window.clearTimeout(_this._scrollDetectionTO);
      _this._scrollDetectionTO = global.window ? global.window.setTimeout(_this._scrollDetectionCallback, _this.props.scrollDetectionThreshold || 0) : null;
    };

    _this._scrollDetectionCallback = function () {
      _this._scrollDetectionTO = null;

      _this.eventEmitter.emit("scrollStop", _this.getScrollValues());
    };

    _this.state = {
      trackXVisible: false,
      trackYVisible: false,
      isRTL: _this.props.rtl
    };
    _this.scrollValues = _this.getScrollValues(true);
    _this.eventEmitter = new Emittr(15);
    _this.props.onUpdate && _this.eventEmitter.on("update", _this.props.onUpdate);
    _this.props.onScroll && _this.eventEmitter.on("scroll", _this.props.onScroll);
    _this.props.onScrollStart && _this.eventEmitter.on("scrollStart", _this.props.onScrollStart);
    _this.props.onScrollEnd && _this.eventEmitter.on("scrollEnd", _this.props.onScrollEnd);
    _this.id = uuid();
    return _this;
  }

  _createClass(Scrollbar, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.contentElement) {
        this.setState(function () {
          throw new Error("content element was not created. Possibly you haven't provided HTMLElement to renderer's `elementRef` function.");
        });
        return;
      }

      if (!this.props.native) {
        if (!this.holderElement) {
          this.setState(function () {
            throw new Error("holder element was not created. Possibly you haven't provided HTMLElement to renderer's `elementRef` function.");
          });
          return;
        }

        if (!this.wrapperElement) {
          this.setState(function () {
            throw new Error("wrapper element was not created. Possibly you haven't provided HTMLElement to renderer's `elementRef` function.");
          });
          return;
        }
      }

      Loop.addTarget(this);

      if (typeof this.props.scrollTop !== "undefined") {
        this.contentElement.scrollTop = this.props.scrollTop;
      }

      if (typeof this.props.scrollLeft !== "undefined") {
        this.contentElement.scrollLeft = this.props.scrollLeft;
      }

      this.update(true);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      Loop.removeTarget(this);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (!this.contentElement) {
        return;
      }

      if (this.props.rtl !== prevProps.rtl && this.props.rtl !== this.state.isRTL) {
        this.setState({
          isRTL: this.props.rtl
        });
      }

      if (this.state.isRTL !== prevState.isRTL) {
        this.update();
      }

      if (typeof this.props.scrollTop !== "undefined" && this.props.scrollTop !== this.contentElement.scrollTop) {
        this.contentElement.scrollTop = this.props.scrollTop;
      }

      if (typeof this.props.scrollLeft !== "undefined" && this.props.scrollLeft !== this.contentElement.scrollLeft) {
        this.contentElement.scrollLeft = this.props.scrollLeft;
      }

      if (prevProps.onUpdate !== this.props.onUpdate) {
        prevProps.onUpdate && this.eventEmitter.off("update", prevProps.onUpdate);
        this.props.onUpdate && this.eventEmitter.on("update", this.props.onUpdate);
      }

      if (prevProps.onScroll !== this.props.onScroll) {
        prevProps.onScroll && this.eventEmitter.off("scroll", prevProps.onScroll);
        this.props.onScroll && this.eventEmitter.on("scroll", this.props.onScroll);
      }

      if (prevProps.onScrollStart !== this.props.onScrollStart) {
        prevProps.onScrollStart && this.eventEmitter.off("scrollStart", prevProps.onScrollStart);
        this.props.onScrollStart && this.eventEmitter.on("scrollStart", this.props.onScrollStart);
      }

      if (prevProps.onScrollEnd !== this.props.onScrollEnd) {
        prevProps.onScrollEnd && this.eventEmitter.off("scrollEnd", prevProps.onScrollEnd);
        this.props.onScrollEnd && this.eventEmitter.on("scrollEnd", this.props.onScrollEnd);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          createContext = _this$props.createContext,
          rtl = _this$props.rtl,
          native = _this$props.native,
          momentum = _this$props.momentum,
          noDefaultStyles = _this$props.noDefaultStyles,
          noScrollX = _this$props.noScrollX,
          noScrollY = _this$props.noScrollY,
          noScroll = _this$props.noScroll,
          permanentTrackX = _this$props.permanentTrackX,
          permanentTrackY = _this$props.permanentTrackY,
          permanentTracks = _this$props.permanentTracks,
          removeTracksWhenNotUsed = _this$props.removeTracksWhenNotUsed,
          removeTrackYWhenNotUsed = _this$props.removeTrackYWhenNotUsed,
          removeTrackXWhenNotUsed = _this$props.removeTrackXWhenNotUsed,
          minimalThumbSize = _this$props.minimalThumbSize,
          maximalThumbSize = _this$props.maximalThumbSize,
          minimalThumbXSize = _this$props.minimalThumbXSize,
          maximalThumbXSize = _this$props.maximalThumbXSize,
          minimalThumbYSize = _this$props.minimalThumbYSize,
          maximalThumbYSize = _this$props.maximalThumbYSize,
          fallbackScrollbarWidth = _this$props.fallbackScrollbarWidth,
          trackClickBehavior = _this$props.trackClickBehavior,
          scrollDetectionThreshold = _this$props.scrollDetectionThreshold,
          propsWrapperProps = _this$props.wrapperProps,
          propsContentProps = _this$props.contentProps,
          propsTrackXProps = _this$props.trackXProps,
          propsTrackYProps = _this$props.trackYProps,
          propsThumbXProps = _this$props.thumbXProps,
          propsThumbYProps = _this$props.thumbYProps,
          propsScrollbarWidth = _this$props.scrollbarWidth,
          elementRef = _this$props.elementRef,
          renderer = _this$props.renderer,
          onUpdate = _this$props.onUpdate,
          onScroll = _this$props.onScroll,
          onScrollStart = _this$props.onScrollStart,
          onScrollEnd = _this$props.onScrollEnd,
          translateContentSizesToHolder = _this$props.translateContentSizesToHolder,
          translateContentSizeYToHolder = _this$props.translateContentSizeYToHolder,
          translateContentSizeXToHolder = _this$props.translateContentSizeXToHolder,
          children = _this$props.children,
          props = _objectWithoutProperties(_this$props, ["createContext", "rtl", "native", "momentum", "noDefaultStyles", "noScrollX", "noScrollY", "noScroll", "permanentTrackX", "permanentTrackY", "permanentTracks", "removeTracksWhenNotUsed", "removeTrackYWhenNotUsed", "removeTrackXWhenNotUsed", "minimalThumbSize", "maximalThumbSize", "minimalThumbXSize", "maximalThumbXSize", "minimalThumbYSize", "maximalThumbYSize", "fallbackScrollbarWidth", "trackClickBehavior", "scrollDetectionThreshold", "wrapperProps", "contentProps", "trackXProps", "trackYProps", "thumbXProps", "thumbYProps", "scrollbarWidth", "elementRef", "renderer", "onUpdate", "onScroll", "onScrollStart", "onScrollEnd", "translateContentSizesToHolder", "translateContentSizeYToHolder", "translateContentSizeXToHolder", "children"]);

      if (native) {
        this.elementRefHolder(null);
        this.elementRefWrapper(null);
        this.elementRefTrackX(null);
        this.elementRefTrackY(null);
        this.elementRefThumbX(null);
        this.elementRefThumbY(null);
        return createElement("div", {
          key: "ScrollbarCustom",
          className: cnb("ScrollbarsCustom native", {
            trackYVisible: this.state.trackYVisible,
            trackXVisible: this.state.trackXVisible,
            rtl: this.state.isRTL
          }, this.props.className),
          style: _objectSpread({}, this.props.style, rtl && {
            direction: "rtl"
          }, momentum && {
            WebkitOverflowScrolling: "touch"
          }, {
            overflowX: noScroll || noScrollX ? "hidden" : permanentTracks || permanentTrackX ? "scroll" : "auto",
            overflowY: noScroll || noScrollY ? "hidden" : permanentTracks || permanentTrackY ? "scroll" : "auto"
          }),
          onScroll: this.handleContentScroll,
          children: children,
          ref: this.elementRefContent
        });
      }

      var styles = Scrollbar.calculateStyles(this.props, this.state, this.scrollValues, typeof propsScrollbarWidth !== "undefined" ? propsScrollbarWidth : getScrollbarWidth());

      var contentProps = _objectSpread({}, propsContentProps, {
        key: "ScrollbarCustom-content",
        className: cnb("ScrollbarContent", propsContentProps.className),
        style: styles.content,
        onScroll: this.handleContentScroll,
        children: createContext ? createElement(ScrollbarContext.Provider, {
          value: {
            parentScrollbar: this
          }
        }, children) : children
      });

      if (propsContentProps.renderer) {
        delete contentProps.ref;
        contentProps.elementRef = this.elementRefContent;
      } else {
        delete contentProps.elementRef;
        contentProps.ref = this.elementRefContent;
      }

      var wrapperProps = _objectSpread({}, propsWrapperProps, {
        key: "ScrollbarCustom-wrapper",
        className: cnb("ScrollbarWrapper", propsWrapperProps.className),
        style: styles.wrapper,
        children: propsContentProps.renderer ? propsContentProps.renderer(contentProps) : createElement("div", Object.assign({}, contentProps))
      });

      if (propsWrapperProps.renderer) {
        delete wrapperProps.ref;
        wrapperProps.elementRef = this.elementRefWrapper;
      } else {
        delete wrapperProps.elementRef;
        wrapperProps.ref = this.elementRefWrapper;
      }

      var holderProps = _objectSpread({}, props, {
        key: "ScrollbarCustom-holder_" + this.id,
        className: cnb("ScrollbarsCustom", {
          trackYVisible: this.state.trackYVisible,
          trackXVisible: this.state.trackXVisible,
          rtl: this.state.isRTL
        }, this.props.className),
        style: styles.holder
      });

      if (renderer) {
        delete holderProps.ref;
        holderProps.elementRef = this.elementRefHolder;
      } else {
        delete holderProps.elementRef;
        holderProps.ref = this.elementRefHolder;
      }

      var holderChildren = [propsWrapperProps.renderer ? propsWrapperProps.renderer(wrapperProps) : createElement("div", Object.assign({}, wrapperProps))];

      if (this.state.trackYVisible || !removeTracksWhenNotUsed && !removeTrackYWhenNotUsed) {
        var thumbYProps = _objectSpread({}, propsThumbYProps, {
          key: "ScrollbarCustom-thumbY",
          style: styles.thumbY,
          elementRef: this.elementRefThumbY,
          onDrag: this.handleThumbYDrag,
          onDragEnd: this.handleThumbYDrag
        });

        var trackYProps = _objectSpread({}, propsTrackYProps, {
          key: "ScrollbarCustom-trackY",
          style: styles.trackY,
          elementRef: this.elementRefTrackY,
          onClick: this.handleTrackYClick,
          onWheel: this.handleTrackYMouseWheel,
          children: createElement(ScrollbarThumb, Object.assign({
            axis: DIRECTION_AXIS.Y
          }, thumbYProps, {
            ref: undefined
          }))
        });

        holderChildren.push(createElement(ScrollbarTrack, Object.assign({
          axis: DIRECTION_AXIS.Y
        }, trackYProps, {
          ref: undefined
        })));
      } else {
        this.elementRefTrackY(null);
        this.elementRefThumbY(null);
      }

      if (this.state.trackXVisible || !removeTracksWhenNotUsed && !removeTrackXWhenNotUsed) {
        var thumbXProps = _objectSpread({}, propsThumbXProps, {
          key: "ScrollbarCustom-thumbX",
          style: styles.thumbX,
          elementRef: this.elementRefThumbX,
          onDrag: this.handleThumbXDrag,
          onDragEnd: this.handleThumbXDrag
        });

        var trackXProps = _objectSpread({}, propsTrackXProps, {
          key: "ScrollbarCustom-trackX",
          style: styles.trackX,
          elementRef: this.elementRefTrackX,
          onClick: this.handleTrackXClick,
          onWheel: this.handleTrackXMouseWheel,
          children: createElement(ScrollbarThumb, Object.assign({
            axis: DIRECTION_AXIS.X
          }, thumbXProps, {
            ref: undefined
          }))
        });

        holderChildren.push(createElement(ScrollbarTrack, Object.assign({
          axis: DIRECTION_AXIS.X
        }, trackXProps, {
          ref: undefined
        })));
      } else {
        this.elementRefTrackX(null);
        this.elementRefThumbX(null);
      }

      holderProps.children = holderChildren;
      return renderer ? renderer(holderProps) : createElement("div", Object.assign({}, holderProps));
    }
  }, {
    key: "scrollTop",
    get: function get() {
      if (this.contentElement) {
        return this.contentElement.scrollTop;
      }

      return 0;
    },
    set: function set(top) {
      if (this.contentElement) {
        this.contentElement.scrollTop = top;
        this.update();
      }
    }
  }, {
    key: "scrollLeft",
    get: function get() {
      if (this.contentElement) {
        return this.contentElement.scrollLeft;
      }

      return 0;
    },
    set: function set(left) {
      if (this.contentElement) {
        this.contentElement.scrollLeft = left;
      }
    }
  }, {
    key: "scrollHeight",
    get: function get() {
      if (this.contentElement) {
        return this.contentElement.scrollHeight;
      }

      return 0;
    }
  }, {
    key: "scrollWidth",
    get: function get() {
      if (this.contentElement) {
        return this.contentElement.scrollWidth;
      }

      return 0;
    }
  }, {
    key: "clientHeight",
    get: function get() {
      if (this.contentElement) {
        return this.contentElement.clientHeight;
      }

      return 0;
    }
  }, {
    key: "clientWidth",
    get: function get() {
      if (this.contentElement) {
        return this.contentElement.clientWidth;
      }

      return 0;
    }
  }], [{
    key: "calculateStyles",
    value: function calculateStyles(props, state, scrollValues, scrollbarWidth) {
      var _objectSpread2, _objectSpread3;

      var useDefaultStyles = !props.noDefaultStyles;
      return {
        holder: _objectSpread({}, useDefaultStyles && defaultStyles.holder, {
          position: "relative"
        }, props.style),
        wrapper: _objectSpread({}, useDefaultStyles && _objectSpread({}, defaultStyles.wrapper, (_objectSpread2 = {}, _defineProperty(_objectSpread2, state.isRTL ? "left" : "right", state.trackYVisible ? 10 : 0), _defineProperty(_objectSpread2, "bottom", state.trackXVisible ? 10 : 0), _objectSpread2)), props.wrapperProps.style, {
          position: "absolute",
          overflow: "hidden"
        }),
        content: _objectSpread({
          position: "absolute",
          top: 0,
          left: 0,
          bottom: 0,
          right: 0
        }, props.contentProps.style, typeof props.rtl !== "undefined" && {
          direction: props.rtl ? "rtl" : "ltr"
        }, props.momentum && {
          WebkitOverflowScrolling: "touch"
        }, (_objectSpread3 = {
          overflowY: scrollValues.scrollYPossible ? "scroll" : "hidden",
          overflowX: scrollValues.scrollXPossible ? "scroll" : "hidden",
          paddingBottom: !scrollbarWidth && scrollValues.scrollXPossible ? props.fallbackScrollbarWidth : undefined,
          marginBottom: scrollValues.scrollXPossible ? -(scrollbarWidth || props.fallbackScrollbarWidth) : undefined
        }, _defineProperty(_objectSpread3, state.isRTL ? "paddingLeft" : "paddingRight", !scrollbarWidth && scrollValues.scrollYPossible ? props.fallbackScrollbarWidth : undefined), _defineProperty(_objectSpread3, state.isRTL ? "marginLeft" : "marginRight", scrollValues.scrollYPossible ? -(scrollbarWidth || props.fallbackScrollbarWidth) : undefined), _objectSpread3)),
        trackX: _objectSpread({}, useDefaultStyles && defaultStyles.track.common, useDefaultStyles && defaultStyles.track.x, props.trackXProps.style, !state.trackXVisible && {
          display: "none"
        }),
        trackY: _objectSpread({}, useDefaultStyles && defaultStyles.track.common, useDefaultStyles && defaultStyles.track.y, _defineProperty({}, state.isRTL ? "left" : "right", 0), props.trackYProps.style, !state.trackYVisible && {
          display: "none"
        }),
        thumbX: _objectSpread({}, useDefaultStyles && defaultStyles.thumb.common, useDefaultStyles && defaultStyles.thumb.x, props.thumbXProps.style),
        thumbY: _objectSpread({}, useDefaultStyles && defaultStyles.thumb.common, useDefaultStyles && defaultStyles.thumb.y, props.thumbYProps.style)
      };
    }
  }]);

  return Scrollbar;
}(Component);

Scrollbar.contextType = ScrollbarContext;
Scrollbar.propTypes = {
  createContext: bool,
  rtl: bool,
  native: bool,
  momentum: bool,
  noDefaultStyles: bool,
  minimalThumbSize: number,
  maximalThumbSize: number,
  minimalThumbXSize: number,
  maximalThumbXSize: number,
  minimalThumbYSize: number,
  maximalThumbYSize: number,
  noScrollX: bool,
  noScrollY: bool,
  noScroll: bool,
  permanentTrackX: bool,
  permanentTrackY: bool,
  permanentTracks: bool,
  translateContentSizesToHolder: bool,
  translateContentSizeYToHolder: bool,
  translateContentSizeXToHolder: bool,
  removeTracksWhenNotUsed: bool,
  removeTrackYWhenNotUsed: bool,
  removeTrackXWhenNotUsed: bool,
  trackClickBehavior: oneOf([SCROLLBAR_TRACK_CLICK_BEHAVIOR.JUMP, SCROLLBAR_TRACK_CLICK_BEHAVIOR.STEP]),
  scrollbarWidth: number,
  fallbackScrollbarWidth: number,
  scrollDetectionThreshold: number,
  scrollTop: number,
  scrollLeft: number,
  className: string,
  wrapperProps: object,
  contentProps: object,
  trackXProps: object,
  trackYProps: object,
  thumbXProps: object,
  thumbYProps: object,
  onUpdate: func,
  onScroll: func,
  onScrollStart: func,
  onScrollEnd: func
};
Scrollbar.defaultProps = {
  momentum: true,
  minimalThumbSize: 30,
  fallbackScrollbarWidth: 20,
  trackClickBehavior: SCROLLBAR_TRACK_CLICK_BEHAVIOR.JUMP,
  scrollDetectionThreshold: 100,
  wrapperProps: {},
  contentProps: {},
  trackXProps: {},
  trackYProps: {},
  thumbXProps: {},
  thumbYProps: {}
};
var defaultStyles = {
  holder: {
    position: "relative",
    width: "100%",
    height: "100%"
  },
  wrapper: {
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
  },
  content: {
    position: "absolute",
    top: 0,
    left: 0,
    bottom: 0,
    right: 0
  },
  track: {
    common: {
      position: "absolute",
      overflow: "hidden",
      borderRadius: 4,
      background: "rgba(0,0,0,.1)",
      userSelect: "none"
    },
    x: {
      height: 10,
      width: "calc(100% - 20px)",
      bottom: 0,
      left: 10
    },
    y: {
      width: 10,
      height: "calc(100% - 20px)",
      top: 10
    }
  },
  thumb: {
    common: {
      cursor: "pointer",
      borderRadius: 4,
      background: "rgba(0,0,0,.4)"
    },
    x: {
      height: "100%",
      width: 0
    },
    y: {
      width: "100%",
      height: 0
    }
  }
};
export default Scrollbar;
export { Scrollbar, ScrollbarContext };